export default "__VITE_ASSET__DwvPZ6Cz__"